import propTypes from 'prop-types';

import { RelatedProduct } from './RelatedProduct/RelatedProduct.jsx';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
import React, { useState, useEffect, useMemo } from 'react';

import {
  DIR,
  RELATED_PRODUCTS_SLIDER
} from '../../../../../constants/constants';
import { PesIcon } from '@pes-ui/components-react';

/**
 * @typedef {import('../../../../../../services/related-products-api').RelatedProductsProduct} RelatedProductsProduct
 */

/**
 * @param {object} props
 * @param {RelatedProductsProduct[]} props.products
 * @param {string} props.parentSkuID
 * @returns {JSX.Element}
 */
const RelatedProducts = ({ products, parentSkuID }) => {

  const productsLength = products.length;
  const isRtl = document.dir === DIR.rtl;
  const [noOfSlides, setNoOfSlides] = useState(RELATED_PRODUCTS_SLIDER.initialValue);
  const [position, setPosition] = useState(RELATED_PRODUCTS_SLIDER.initialValue);

  useEffect(() => {
    let numberOfProductsPerSlide = window.matchMedia("(max-width: 1200px)").matches ? RELATED_PRODUCTS_SLIDER.mobileProductsMax : RELATED_PRODUCTS_SLIDER.desktopProductsMax;
    let slidesLength = productsLength - numberOfProductsPerSlide;
    setPosition(RELATED_PRODUCTS_SLIDER.initialValue);
    setNoOfSlides(slidesLength >= RELATED_PRODUCTS_SLIDER.initialValue ? slidesLength : RELATED_PRODUCTS_SLIDER.initialValue);

    const handleResize = (ev) => {
      if (window.matchMedia("(max-width: 1200px)").matches) {
        numberOfProductsPerSlide = RELATED_PRODUCTS_SLIDER.mobileProductsMax;
        slidesLength = productsLength - numberOfProductsPerSlide;
        if (position > RELATED_PRODUCTS_SLIDER.initialValue) {
          this.handlePreviousClick();
        }
      } else {
        numberOfProductsPerSlide = RELATED_PRODUCTS_SLIDER.desktopProductsMax;
        slidesLength = productsLength - numberOfProductsPerSlide;
      }

      setNoOfSlides(slidesLength >= RELATED_PRODUCTS_SLIDER.initialValue ? slidesLength : RELATED_PRODUCTS_SLIDER.initialValue);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [products]);

  const sliderStyle = useMemo(
    () => ({
      transform: `translate3d(-${position * RELATED_PRODUCTS_SLIDER.cardWidth}px, 0px, 0px)`,
      transition: RELATED_PRODUCTS_SLIDER.transitionStyle
    }),
    [position]
  );

  const sliderStyleForRTL = useMemo(
    () => ({
      transform: `translate3d(${position * RELATED_PRODUCTS_SLIDER.cardWidth}px, 0px, 0px)`,
      transition: RELATED_PRODUCTS_SLIDER.transitionStyle
    }),
    [position]
  );

  const handleNextClick = () => {
    setPosition(prevPosition => prevPosition + RELATED_PRODUCTS_SLIDER.step);
  };

  const handlePreviousClick = () => {
    setPosition(prevPosition => prevPosition - RELATED_PRODUCTS_SLIDER.step);
  };

  return (
    <div class="related-slider">
      <div onClick={handlePreviousClick} className={`tabs-arrow tabs-arrow__left ${position === RELATED_PRODUCTS_SLIDER.initialValue ? 'invisible' : ''}`}>
        <PesIcon class="actions-block__icon" color="standard" size={pesIconSizes.SMALL}>
          {isRtl ? 'arrow2_right' : 'arrow2_left' }
        </PesIcon>
      </div>

      <div class="related-slider__main">
        <div class="items-wrapper">
          <ul className="related-section__products" style={isRtl ? sliderStyleForRTL: sliderStyle}>
            {products.map(({ product: { skuId } }) => (
              <RelatedProduct
                skuID={skuId}
                key={skuId}
                parentSkuID={parentSkuID}
              />
            ))}
          </ul>
        </div>
      </div>

      <div onClick={handleNextClick} className={`tabs-arrow tabs-arrow__right ${position >= noOfSlides ? 'invisible' : ''}`}>
        <PesIcon class="actions-block__icon" color="standard" size={pesIconSizes.SMALL}>
          {isRtl ? 'arrow2_left' : 'arrow2_right'}
        </PesIcon>
      </div>
    </div>
  );
}

RelatedProducts.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  products: propTypes.array.isRequired,
  parentSkuID: propTypes.string.isRequired
};

export default RelatedProducts;